import React from 'react';
import {
  useGetRounds,
  useGetCurrentEpoch,
  useGetLastOraclePrice,
} from './context/PredictionsContext';
import RoundCard from './components/RoundCard';

const Positions = ({ view = 'positions', referralAddress }) => {
  const rounds = useGetRounds?.();
  const lastOraclePrice = useGetLastOraclePrice?.();

  const currentEpochRaw = useGetCurrentEpoch?.();
  const currentEpoch = Number(currentEpochRaw ?? 0);

  const cards = [];
  // Expired (up to 4 previous epochs, >= 0)
  for (let i = Math.max(0, currentEpoch - 4); i < currentEpoch - 1; i++) {
    cards.push({
      epoch: i,
      round: rounds && rounds[i] ? rounds[i] : { epoch: i },
      status: 'expired',
    });
  }
  // Live
  cards.push({
    epoch: currentEpoch - 1,
    round: rounds && rounds[currentEpoch - 1] ? rounds[currentEpoch - 1] : { epoch: currentEpoch - 1 },
    status: 'live',
  });
  cards.push({
    epoch: currentEpoch,
    round: rounds && rounds[currentEpoch] ? rounds[currentEpoch] : { epoch: currentEpoch },
    status: 'next',
  });
  // Later
  cards.push({
    epoch: currentEpoch + 1,
    round: rounds && rounds[currentEpoch + 1] ? rounds[currentEpoch + 1] : { epoch: currentEpoch + 1 },
    status: 'later',
  });

  // Mobile view (vertical stacking) vs Desktop view (horizontal scrolling)
  const isMobile = view === 'positions' && window.innerWidth < 768;

  return (
    <div className="w-full h-full overflow-auto bg-black px-4 pt-4 pb-20">
      {isMobile ? (
        // Mobile: Vertical layout
        <div className="items-center flex flex-col space-y-4 pb-20">
          {cards.map(({ epoch, round, status }) => (
            <div key={`${status}-${epoch}`} className="w-full">
              <RoundCard
                round={round}
                epoch={epoch}
                status={status}
                currentEpoch={currentEpoch}
                oraclePrice={status === 'live' ? lastOraclePrice : undefined}
                referralAddress={referralAddress} 
              />
            </div>
          ))}
        </div>
      ) : (
        // Desktop: Horizontal layout
        <div className="pb-4">
          <div className="flex space-x-4 overflow-x-auto pb-4 custom-scrollbar">
            {cards.map(({ epoch, round, status }) => (
              <div
                key={`${status}-${epoch}`}
                className="flex-shrink-0"
                style={{ width: '280px' }}
              >
                <RoundCard
                  round={round}
                  epoch={epoch}
                  status={status}
                  currentEpoch={currentEpoch}
                  oraclePrice={status === 'live' ? lastOraclePrice : undefined}
                  referralAddress={referralAddress} 
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Positions;